import { render } from "./TelegramAddChannel.vue?vue&type=template&id=8d53e352"
import script from "./TelegramAddChannel.vue?vue&type=script&lang=js"
export * from "./TelegramAddChannel.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__